import { render, staticRenderFns } from "./VuetablePaginationWithDropdown.vue?vue&type=template&id=79607ac2"
import script from "./VuetablePaginationWithDropdown.vue?vue&type=script&lang=js"
export * from "./VuetablePaginationWithDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports